var map = {
	"./IMC.vue": [
		"ba47",
		"chunk-2d219ff8"
	],
	"./IMCadultos.vue": [
		"aeae",
		"chunk-2d21403e"
	],
	"./IMCmenores.vue": [
		"0838",
		"chunk-2d0a4b63"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "c021";
module.exports = webpackAsyncContext;